export default __webpack_public_path__ + "static/media/chevron-right.bf1e6b59.svg";